import React, { useMemo } from "react";
import dummy_image from "../../assets/img/default_avatar.jpg";
import moment from "moment";
import { API_URL } from "../../../../config/app-config";

function MessageList({
  handleChatList,
  friend,
  unseenMessageCount,
  lastMessage,
  initialLastMessage,
  isCurrentFriendAvailiable,
  currentFriend,
  userId,
}) {
  let total =
    unseenMessageCount.length > 0 &&
    unseenMessageCount.filter(
      (totalfriend) => +totalfriend.senderId === friend?.userId
    );

  const getList = (lastMessage) => {
    const data =
      lastMessage && Array.isArray(lastMessage) && lastMessage.length > 0
        ? lastMessage
          .filter((message) => message !== null)
          .filter(
            (message) =>
              +message.senderId === friend?.userId ||
              +message.receiverId === friend?.userId
          )
        : initialLastMessage
          .filter((message) => message !== null)
          .filter(
            (message) =>
              +message.senderId === friend?.userId ||
              +message.receiverId === friend?.userId
          );
    return data;
  };

  const filteredLastMessage = useMemo(
    () => getList(lastMessage),
    [lastMessage]
  );

  // Format message preview text
  const getMessagePreview = (message) => {
    if (!message) return "Start a conversation";

    if (message.message?.text !== "") {
      return message.message.text.length > 35
        ? message.message.text.substring(0, 35) + '...'
        : message.message.text;
    } else if (message.message?.image?.length > 0) {
      return "📎 Sent a file";
    } else if (message.message?.meetingLink !== "") {
      return message.message?.isMeetingfinished
        ? "✅ Meeting Finished"
        : "📅 Scheduled a Meeting";
    }
    return "Start a conversation";
  };

  // Format time display
  const formatTime = (timestamp) => {
    if (!timestamp) return "";

    const messageDate = moment(timestamp);
    const now = moment();

    if (messageDate.isSame(now, 'day')) {
      return messageDate.format('h:mm A');
    } else if (messageDate.isSame(now.subtract(1, 'day'), 'day')) {
      return 'Yesterday';
    } else {
      return messageDate.format('MMM DD');
    }
  };

  // Check if this conversation has unread messages
  const hasUnreadMessages = filteredLastMessage[0]?.unseenCount > 0;

  // Check if this is the active conversation
  const isActiveConversation = currentFriend?.userId === friend?.userId;

  return (
    <div
      className={`conversation-list-item ${isActiveConversation ? 'active-conversation' : ''}`}
      onClick={() => handleChatList(friend, filteredLastMessage[0])}
      id={friend?.userId}
    >
      <div className="conversation-avatar-container">
        <img
          src={`${API_URL}auth/image/${friend.profilePhoto}`}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = dummy_image;
          }}
          alt={friend?.userName}
          className="conversation-user-avatar"
        />
        {hasUnreadMessages && (
          <div className="unread-indicator"></div>
        )}
      </div>

      <div className="conversation-content">
        <div className="conversation-header">
          <div className="conversation-user-info">
            <h3 className="conversation-user-name">
              {friend?.userName}
            </h3>
            {filteredLastMessage && filteredLastMessage.length > 0 && (
              <span className="conversation-time">
                {formatTime(filteredLastMessage[0].created_at)}
              </span>
            )}
          </div>

          <div className="conversation-meta">
            {hasUnreadMessages && (
              <span className="unseen-count">
                {filteredLastMessage[0]?.unseenCount}
              </span>
            )}
            {userId === +filteredLastMessage[0]?.senderId && filteredLastMessage[0] && (
              <div className="message-status-indicator">
                <div
                  className={`status-icon ${filteredLastMessage[0]?.status === "seen"
                      ? "status-seen"
                      : filteredLastMessage[0]?.status === "sent"
                        ? "status-sent"
                        : "status-delivered"
                    }`}
                >
                  {filteredLastMessage[0]?.status === "seen" ? "✓✓" : "✓"}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="conversation-preview">
          {filteredLastMessage && filteredLastMessage.length > 0 ? (
            <span className={`preview-text ${hasUnreadMessages ? 'unread' : ''}`}>
              {String(filteredLastMessage[0]?.senderId) === String(userId) ? (
                <span className="friend-indicator">You: </span>
              ) : (
                <span className="you-indicator">{friend?.userName}: </span>
              )}
              {getMessagePreview(filteredLastMessage[0])}
            </span>
          ) : (
            <span className="preview-text empty">Start a conversation</span>
          )}
        </div>

      </div>
    </div>
  );
}

export default MessageList;